module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 18
// module chunks = 431